import { render, staticRenderFns } from "./InviteDetails.vue?vue&type=template&id=76b12c95"
import script from "./InviteDetails.vue?vue&type=script&lang=js"
export * from "./InviteDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports